import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { ChevronRight, Mail, Smartphone } from "lucide-react";

import AuthPage from "../../components/auth/AuthPage";
import { API, ROLE_PASS } from "../../constant/api";
import { errorMessage } from "../../utils/errorMessage";
import sessionAxios from "../../utils/sessionAxios";

const AuthSelect = () => {
  const { state: info } = useLocation() as any;
  const navigate = useNavigate();

  const forward = (path: string) =>
    navigate(path, {
      state: {
        email: info?.email,
        password: info?.password,
        from: info?.from,
        authApp: info?.authApp,
        emailAuth: info?.emailAuth,
      },
    });

  const sendEmailOtp = () => {
    sessionAxios
      .post(API.login, {
        email: info?.email,
        password: info?.password,
        "2faMethod": "email",
        rolePass: ROLE_PASS,
      })
      .catch((e: any) => {
        toast.error(
          errorMessage(
            e?.response?.data?.message || "An error occurred while sending OTP"
          )
        );
      });
  };

  const methods = [
    {
      show: info?.authApp === true,
      icon: Smartphone,
      title: "Google Authenticator",
      description:
        "Send a one time password (OTP) to your Google Authenticator app",
      onSelect: () => forward("/2fa-auth-app"),
    },
    {
      show: info?.emailAuth === true,
      icon: Mail,
      title: "Email",
      description: `Send a one time password (OTP) to your email ${info?.email ?? ""}.`,
      onSelect: () => {
        sendEmailOtp();
        forward("/2fa-auth");
      },
    },
  ].filter((method) => method.show);

  return (
    <AuthPage
      title="Select Authentication"
      description="Choose how you'd like to receive your one time password."
    >
      <div className="divide-y rounded-xl border">
        {methods.map((method) => (
          <button
            key={method.title}
            type="button"
            onClick={method.onSelect}
            className="flex w-full items-center gap-4 p-4 text-left transition-colors hover:bg-accent"
          >
            <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-accent text-primary">
              <method.icon className="size-5" />
            </span>
            <span className="flex-1">
              <span className="block font-sora text-[15px] font-semibold text-foreground">
                {method.title}
              </span>
              <span className="mt-1 block text-[13px] font-medium text-muted-foreground">
                {method.description}
              </span>
            </span>
            <ChevronRight className="size-5 shrink-0 text-muted-foreground" />
          </button>
        ))}
      </div>
    </AuthPage>
  );
};

export default AuthSelect;
